<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid, dirty }">
      <v-row>
        <v-col cols="12" sm="4" class="pb-0 pt-2">
          <v-combobox
            v-model="selected"
            label="Select lookup type"
            :items="items"
            @change="resetValidation($event)"
            :disabled="withData || isOriginal"
          ></v-combobox>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          lg="5"
          :class="$vuetify.breakpoint.smAndDown ? '' : 'text-right pt-6'"
        >
          <v-btn
            class="primary"
            @click="showAddressMissing()"
            :disabled="isOriginal"
            >Can't find address</v-btn
          >
        </v-col>
      </v-row>

      <div v-if="selected !== 'Location ID'">
        <v-row v-if="selected === 'Physical Address'">
          <v-col cols="12" class="pt-0 mt-0 pb-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Search for Address"
              rules="required"
            >
              <v-autocomplete
                :items="addressResults"
                label="Search for physical street Address, not PO Box"
                :search-input.sync="search"
                v-model="streetAddress"
                item-text="formattedAddress"
                item-value="formattedAddress"
                @change="completeAddress"
                persistent-hint
                autocomplete="off"
                :error-messages="errors"
                :disabled="withData"
                :readonly="isOriginal"
                no-filter
                return-object
              >
              </v-autocomplete>
            </ValidationProvider>
          </v-col>
          <!-- <v-col cols="6" md="3" class="py-0">
            <v-text-field
              disabled
              label="Street Address"
              type="text"
              name="streetAddress"
              v-model="result.streetAddress"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3" class="py-0">
            <v-text-field
              disabled
              label="Suburb"
              type="text"
              name="suburb"
              v-model="result.suburb"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3" class="py-0">
            <v-text-field
              disabled
              label="State"
              name="state"
              v-model="result.state"
              autocomplete="off"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="3" class="py-0">
            <v-text-field
              disabled
              label="Postcode"
              type="text"
              name="postCode"
              v-model="result.postCode"
              autocomplete="off"
            ></v-text-field>
          </v-col> -->
        </v-row>

        <v-row v-if="selected === 'Geocode'">
          <v-col cols="6" class="mt-0 pb-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Latitude"
              rules="required|between:-180.999999,180.999999"
            >
              <v-text-field
                label="Latitude"
                v-model="latitude"
                outlined
                :error-messages="errors"
                autocomplete="off"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
          <v-col cols="6" class="mt-0 pb-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="Longitude"
              rules="required|between:-180.999999,180.999999"
            >
              <v-text-field
                label="Longitude"
                v-model="longitude"
                outlined
                :error-messages="errors"
                autocomplete="off"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row v-if="selected === 'GNAF ID'">
          <v-col cols="12" class="mt-0 pb-0">
            <ValidationProvider
              v-slot="{ errors }"
              name="GNAF ID"
              rules="required"
            >
              <v-text-field
                label="GNAF ID"
                v-model="gnafId"
                outlined
                :error-messages="errors"
                autocomplete="off"
              ></v-text-field>
            </ValidationProvider>
          </v-col>
        </v-row>

        <v-row
          v-if="
            (selected !== 'Location ID' &&
              $route.path === '/service-qualification') ||
            $route.path === '/'
          "
        >
          <v-col class="pt-0 pb-0">
            <v-btn
              :disabled="invalid || !dirty || withData || isOriginal"
              class="primary mr-5"
              @click="submit()"
              v-if="selected !== 'Physical Address'"
              >Submit</v-btn
            >
            <v-btn
              :disabled="invalid || !dirty || withData || isOriginal"
              @click="clear()"
              >Clear</v-btn
            >
          </v-col>
        </v-row>
      </div>
    </ValidationObserver>
    <invalid-address
      :showDialog="showDialog"
      :invalidItems="invalidItems"
      :isInvalid="isInvalid"
      :isValidated="isValidated"
      :title="title"
      @close="close"
    ></invalid-address>
  </div>
</template>

<script>
export default {
  name: "QualificationForm",
  data: () => ({
    items: ["Physical Address", "Location ID", "Geocode", "GNAF ID"],
    selected: "Physical Address",
    result: {
      suburb: "",
      state: "",
      postCode: "",
      streetAddress: "",
    },
    search: null,
    streetAddress: "",
    longitude: "",
    latitude: "",
    gnafId: "",
    withData: false,
    queryAddress: [],
    showDialog: false,
    invalidItems: [],
    isInvalid: false,
    title: "",
    isValidated: false,
    processCount: 0,
  }),
  methods: {
    submit() {
      let vm = this;
      let payload = {};
      let data = {};
      let methodType = "";

      switch (vm.selected) {
        case "Location ID":
          methodType = "NBN_LOCATION_ID";
          data = { LocationId: vm.locationId };
          break;
        case "Physical Address":
          methodType = "PHYSICAL_ADDRESS";
          data = {
            StateOrProvince: vm.fullAddress.state,
            Postcode: vm.fullAddress.postcode,
            Suburb: vm.fullAddress.suburb,
            StreetName: vm.fullAddress.street_name,
            StreetType: vm.fullAddress.street_type,
            StreetNrFirst: vm.fullAddress.street_number,
          };

          break;
        case "Geocode":
          methodType = "GEOCODE";
          data = {
            Longtitude: vm.longitude,
            Latitude: vm.latitude,
          };
          break;
        case "GNAF ID":
          methodType = "GNAF_ID";
          data = { Gnafld: vm.gnafId };
          break;
      }

      payload = {
        addressCheckServiceType: "NBN",
        addressCheckMethodType: methodType,
        Address: data,
      };

      vm.addressQuery(payload).then((data) => {
        if (data.data.status === 400 && vm.processCount < 2) {
          vm.processCount = vm.processCount + 1;
          vm.redoValidateAddress();
        } else {
          if (data.data) {
            vm.setResult(data.data);

            let details = {
              queryAddress: vm.queryAddress,
              streetAddress: vm.streetAddress,
              populatedAddress: vm.result,
            };
            vm.$emit("showResultSection", details);
          }
        }
      });
    },
    setResult(result) {
      let vm = this;
      vm.showResult = true;
      vm.queryAddress = vm.reformatResult(result.addresses);
      vm.showResult = true;
    },
    reformatResult(result) {
      let vm = this;
      let newAddress = [];
      result.forEach((x) => {
        let addressFormat = {
          addressSiteName: vm.setValue(x, "addressSiteName"),
          streetNrFirst: vm.setValue(x, "streetNrFirst"),
          streetNrLast: vm.setValue(x, "streetNrLast"),
          streetName: vm.setValue(x, "streetName"),
          streetType: vm.setValue(x, "streetType"),
          suburb: vm.setValue(x, "suburb"),
          postcode: vm.setValue(x, "postcode"),
          stateOrProvince: vm.setValue(x, "stateOrProvince"),
          longitude: vm.setValue(x, "longitude"),
          latitude: vm.setValue(x, "latitude"),
          locationId: vm.setValue(x, "locationId"),
          formattedAddress: vm.setValue(x, "formattedAddress"),
          lotNumber: vm.setValue(x, "lotNumber")
            ? vm.setValue(x, "lotNumber")
            : "",
        };

        newAddress.push(addressFormat);
      });

      return newAddress;
    },
    setValue(address, name) {
      let value = "";
      address.forEach((x) => {
        if (x.name === name) value = x.value;
      });

      return value;
    },
    clear() {
      let vm = this;
      vm.result = {
        suburb: "",
        state: "",
        postCode: "",
        streetAddress: "",
      };
      vm.streetAddress = "";
      vm.longitude = "";
      vm.latitude = "";
      vm.gnafId = "";
      vm.setLocationID("");
      vm.SET_ADDRESS_RESULTS([]);
      vm.setSqResult({});
      vm.resetFormattedSQResult();
      vm.$emit("changed");
    },
    resetValidation(event) {
      let vm = this;
      vm.selected = event;
      vm.result = {
        suburb: "",
        state: "",
        postCode: "",
        streetAddress: "",
      };
      vm.setLocationID("");
      vm.resetFormattedSQResult();
      vm.id = "";
      vm.queryAddress = [];
      vm.$emit("changed", event);
      vm.$refs.observer.reset();
    },
    completeAddress(address) {
      let vm = this;
      vm.processCount = 0;
      vm.$emit("changed");
      vm.setSearchResultId(address.search_result_id);

      // if(vm.streetAddress === "Can't find address"){
      //   vm.showAddressDialog("Address Not Found");
      // }else{
      vm.getAddress();
      // }
    },
    getAddress() {
      let vm = this;
      vm.getFullAddress().then((addressResults) => {
        if (addressResults.gnafId === '') {
          if (addressResults.state === "") vm.invalidItems.push("state");
          else if (addressResults.postcode === "")
            vm.invalidItems.push("postcode");
          else if (addressResults.suburb === "")
            vm.invalidItems.push("postcode");
          else if (addressResults.street_name === "")
            vm.invalidItems.push("street name");
          else if (addressResults.street_type === "")
            vm.invalidItems.push("street type");
          else if (addressResults.street_number === "")
            vm.invalidItems.push("street number");
          vm.isValidated = true;
          vm.isInvalid = true;
          vm.showAddressDialog("Error Details");
        } else {
          vm.submit();
        }
      });
    },
    redoValidateAddress() {
      let vm = this;
      vm.getAddress();
    },
    showAddressDialog(title) {
      let vm = this;
      vm.title = title;
      vm.showDialog = true;
    },
    populateAddress(address) {
      let vm = this;
      if (address !== undefined) {
        vm.result.suburb = address.suburb;
        vm.result.state = address.state;
        vm.result.postCode = address.postcode;
        vm.result.streetAddress = address.street_address;
      } else {
        vm.result.suburb = vm.sqResult.addressField.suburb;
        vm.result.state = vm.sqResult.addressField.stateOrProvince;
        vm.result.postCode = vm.sqResult.addressField.postcode;
        vm.result.streetAddress =
          vm.sqResult.addressField.formattedAddress.substring(
            0,
            address.indexOf(",")
          );
      }
    },
    close() {
      let vm = this;
      vm.showDialog = false;
      vm.invalidItems = [];
      vm.isValidated = false;
      vm.isInvalid = false;
      vm.title = "";
    },
    showAddressMissing() {
      let vm = this;
      vm.showAddressDialog("Address Not Found");
    },
  },
  computed: {
    isGoogleChrome() {
      return (
        /Chrome/.test(navigator.userAgent) &&
        /Google Inc/.test(navigator.vendor)
      );
    },
  },
  watch: {
    search: function (val) {
      let vm = this;
      if (val !== null && !vm.isOriginal) {
        if (val.length > 4) vm.searchAddress(val);
      }
    },
    selected: function () {
      let vm = this;
      vm.streetAddress = "";
      if (vm.selected === "Location ID") vm.$emit("toggleInput", true);
      else vm.$emit("toggleInput", false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
